/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { PagedResponsePartnerUserListResponse } from '../model';
// @ts-ignore
import { PartnerUserBriefResponse } from '../model';
// @ts-ignore
import { PartnerUserDetailResponse } from '../model';
// @ts-ignore
import { RegisterUserByAdminRequest } from '../model';
// @ts-ignore
import { RegisterUserByAdminResponse } from '../model';
// @ts-ignore
import { UpdateUserByAdminRequest } from '../model';
/**
 * AdminUserControllerApi - axios parameter creator
 * @export
 */
export const AdminUserControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {RegisterUserByAdminRequest} registerUserByAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserByAdmin: async (registerUserByAdminRequest: RegisterUserByAdminRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerUserByAdminRequest' is not null or undefined
            assertParamExists('createUserByAdmin', 'registerUserByAdminRequest', registerUserByAdminRequest)
            const localVarPath = `/admin/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerUserByAdminRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById: async (userId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserById', 'userId', userId)
            const localVarPath = `/admin/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBriefUsers: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/users/brief`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [query] 
         * @param {number} [minTotalBalance] 
         * @param {number} [maxTotalBalance] 
         * @param {string} [minSubscriptionDate] 
         * @param {string} [maxSubscriptionDate] 
         * @param {string} [channel] 
         * @param {string} [dietitianId] 
         * @param {string} [planId] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers: async (query?: string, minTotalBalance?: number, maxTotalBalance?: number, minSubscriptionDate?: string, maxSubscriptionDate?: string, channel?: string, dietitianId?: string, planId?: string, page?: number, size?: number, sort?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (minTotalBalance !== undefined) {
                localVarQueryParameter['minTotalBalance'] = minTotalBalance;
            }

            if (maxTotalBalance !== undefined) {
                localVarQueryParameter['maxTotalBalance'] = maxTotalBalance;
            }

            if (minSubscriptionDate !== undefined) {
                localVarQueryParameter['minSubscriptionDate'] = (minSubscriptionDate as any instanceof Date) ?
                    (minSubscriptionDate as any).toISOString().substring(0,10) :
                    minSubscriptionDate;
            }

            if (maxSubscriptionDate !== undefined) {
                localVarQueryParameter['maxSubscriptionDate'] = (maxSubscriptionDate as any instanceof Date) ?
                    (maxSubscriptionDate as any).toISOString().substring(0,10) :
                    maxSubscriptionDate;
            }

            if (channel !== undefined) {
                localVarQueryParameter['channel'] = channel;
            }

            if (dietitianId !== undefined) {
                localVarQueryParameter['dietitianId'] = dietitianId;
            }

            if (planId !== undefined) {
                localVarQueryParameter['planId'] = planId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {UpdateUserByAdminRequest} updateUserByAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserByAdmin: async (userId: string, updateUserByAdminRequest: UpdateUserByAdminRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserByAdmin', 'userId', userId)
            // verify required parameter 'updateUserByAdminRequest' is not null or undefined
            assertParamExists('updateUserByAdmin', 'updateUserByAdminRequest', updateUserByAdminRequest)
            const localVarPath = `/admin/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserByAdminRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminUserControllerApi - functional programming interface
 * @export
 */
export const AdminUserControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminUserControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {RegisterUserByAdminRequest} registerUserByAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUserByAdmin(registerUserByAdminRequest: RegisterUserByAdminRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisterUserByAdminResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUserByAdmin(registerUserByAdminRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserById(userId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerUserDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserById(userId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBriefUsers(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PartnerUserBriefResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBriefUsers(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [query] 
         * @param {number} [minTotalBalance] 
         * @param {number} [maxTotalBalance] 
         * @param {string} [minSubscriptionDate] 
         * @param {string} [maxSubscriptionDate] 
         * @param {string} [channel] 
         * @param {string} [dietitianId] 
         * @param {string} [planId] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUsers(query?: string, minTotalBalance?: number, maxTotalBalance?: number, minSubscriptionDate?: string, maxSubscriptionDate?: string, channel?: string, dietitianId?: string, planId?: string, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedResponsePartnerUserListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUsers(query, minTotalBalance, maxTotalBalance, minSubscriptionDate, maxSubscriptionDate, channel, dietitianId, planId, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} userId 
         * @param {UpdateUserByAdminRequest} updateUserByAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserByAdmin(userId: string, updateUserByAdminRequest: UpdateUserByAdminRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserByAdmin(userId, updateUserByAdminRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminUserControllerApi - factory interface
 * @export
 */
export const AdminUserControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminUserControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {RegisterUserByAdminRequest} registerUserByAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserByAdmin(registerUserByAdminRequest: RegisterUserByAdminRequest, options?: any): AxiosPromise<RegisterUserByAdminResponse> {
            return localVarFp.createUserByAdmin(registerUserByAdminRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById(userId: string, options?: any): AxiosPromise<PartnerUserDetailResponse> {
            return localVarFp.getUserById(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBriefUsers(options?: any): AxiosPromise<Array<PartnerUserBriefResponse>> {
            return localVarFp.listBriefUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [query] 
         * @param {number} [minTotalBalance] 
         * @param {number} [maxTotalBalance] 
         * @param {string} [minSubscriptionDate] 
         * @param {string} [maxSubscriptionDate] 
         * @param {string} [channel] 
         * @param {string} [dietitianId] 
         * @param {string} [planId] 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsers(query?: string, minTotalBalance?: number, maxTotalBalance?: number, minSubscriptionDate?: string, maxSubscriptionDate?: string, channel?: string, dietitianId?: string, planId?: string, page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PagedResponsePartnerUserListResponse> {
            return localVarFp.listUsers(query, minTotalBalance, maxTotalBalance, minSubscriptionDate, maxSubscriptionDate, channel, dietitianId, planId, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userId 
         * @param {UpdateUserByAdminRequest} updateUserByAdminRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserByAdmin(userId: string, updateUserByAdminRequest: UpdateUserByAdminRequest, options?: any): AxiosPromise<void> {
            return localVarFp.updateUserByAdmin(userId, updateUserByAdminRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminUserControllerApi - object-oriented interface
 * @export
 * @class AdminUserControllerApi
 * @extends {BaseAPI}
 */
export class AdminUserControllerApi extends BaseAPI {
    /**
     * 
     * @param {RegisterUserByAdminRequest} registerUserByAdminRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserControllerApi
     */
    public createUserByAdmin(registerUserByAdminRequest: RegisterUserByAdminRequest, options?: AxiosRequestConfig) {
        return AdminUserControllerApiFp(this.configuration).createUserByAdmin(registerUserByAdminRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserControllerApi
     */
    public getUserById(userId: string, options?: AxiosRequestConfig) {
        return AdminUserControllerApiFp(this.configuration).getUserById(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserControllerApi
     */
    public listBriefUsers(options?: AxiosRequestConfig) {
        return AdminUserControllerApiFp(this.configuration).listBriefUsers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [query] 
     * @param {number} [minTotalBalance] 
     * @param {number} [maxTotalBalance] 
     * @param {string} [minSubscriptionDate] 
     * @param {string} [maxSubscriptionDate] 
     * @param {string} [channel] 
     * @param {string} [dietitianId] 
     * @param {string} [planId] 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserControllerApi
     */
    public listUsers(query?: string, minTotalBalance?: number, maxTotalBalance?: number, minSubscriptionDate?: string, maxSubscriptionDate?: string, channel?: string, dietitianId?: string, planId?: string, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig) {
        return AdminUserControllerApiFp(this.configuration).listUsers(query, minTotalBalance, maxTotalBalance, minSubscriptionDate, maxSubscriptionDate, channel, dietitianId, planId, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userId 
     * @param {UpdateUserByAdminRequest} updateUserByAdminRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUserControllerApi
     */
    public updateUserByAdmin(userId: string, updateUserByAdminRequest: UpdateUserByAdminRequest, options?: AxiosRequestConfig) {
        return AdminUserControllerApiFp(this.configuration).updateUserByAdmin(userId, updateUserByAdminRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

